// extracted by mini-css-extract-plugin
export default {"raw-hprim":"_raw-hprim_lT2XBl","upload-label":"_upload-label_7+umyw"};